import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import api from 'api';

/**
 * Whether the signed-in customer already has an ACTIVE subscription, so the
 * à la carte menu can send them to their meal plan instead. Guests and any
 * lookup failure resolve to `hasSubscription: false` — the menu stays usable.
 * `checking` is true only while a signed-in customer's status is being fetched.
 */
export function useSubscriptionGate() {
  const { isAuthenticated, isLoading } = useAuth0();
  const [state, setState] = useState({ checking: false, hasSubscription: false, token: null });

  useEffect(() => {
    if (isLoading) {
      setState((s) => ({ ...s, checking: true }));
      return undefined;
    }
    if (!isAuthenticated) {
      setState({ checking: false, hasSubscription: false, token: null });
      return undefined;
    }

    let cancelled = false;
    setState((s) => ({ ...s, checking: true }));
    (async () => {
      try {
        const { data: auth } = await api.get('/auth/token', { timeout: 15000 });
        const { data } = await api.get(`/orders/${auth.token}/subscriptions`, { timeout: 25000 });
        if (cancelled) return;
        setState({
          checking: false,
          hasSubscription: Boolean(data?.subscriptions?.length),
          token: auth.token,
        });
      } catch {
        if (!cancelled) setState({ checking: false, hasSubscription: false, token: null });
      }
    })();

    return () => { cancelled = true; };
  }, [isAuthenticated, isLoading]);

  return state;
}
